import { render, staticRenderFns } from "./NewsShow.vue?vue&type=template&id=538a13ec&"
import script from "./NewsShow.vue?vue&type=script&lang=js&"
export * from "./NewsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports